<script setup>
import { computed, nextTick, onMounted, ref } from 'vue';
import { useStore } from 'vuex';
import { useRoute, useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';

import Spinner from 'dashboard/components-next/spinner/Spinner.vue';

const store = useStore();
const router = useRouter();
const route = useRoute();
const { t } = useI18n();

const assistants = computed(() => store.getters['brainAssistants/getRecords']);
const isReady = ref(false);

const routeToView = (name, params) => {
  router.replace({ name, params, replace: true });
};

const generateRouterParams = () => {
  if (assistants.value.length > 0) {
    const { id: assistantId } = assistants.value[0];
    return { assistantId };
  }
  return null;
};

const routeToLastActiveAssistant = () => {
  const params = generateRouterParams();

  if (!params) {
    // No assistants — render empty-state template (Brain assistants are
    // admin-provisioned; no tenant-facing create flow exists).
    isReady.value = true;
    return;
  }

  const { navigationPath } = route.params;
  const isAValidRoute = [
    'brain_assistants_faqs_index',
    'brain_assistants_faqs_pending',
    'brain_assistants_knowledge_index',
    'brain_assistants_knowledge_pending',
    'brain_assistants_inboxes_index',
    'brain_assistants_settings_index',
    'brain_assistants_data_manager_settings',
  ].includes(navigationPath);

  const navigateTo = isAValidRoute
    ? navigationPath
    : 'brain_assistants_faqs_index';

  routeToView(navigateTo, {
    accountId: route.params.accountId,
    ...params,
  });
};

const performRouting = async () => {
  await store.dispatch('brainAssistants/get');
  nextTick(() => routeToLastActiveAssistant());
};

onMounted(() => performRouting());
</script>

<template>
  <div
    class="flex items-center justify-center w-full bg-n-surface-1 text-n-slate-11"
  >
    <Spinner v-if="!isReady" />
    <div
      v-else
      class="flex flex-col items-center justify-center max-w-md p-8 text-center"
    >
      <h2 class="mb-2 text-lg font-semibold text-n-slate-12">
        {{ t('BRAIN.NO_ASSISTANT.TITLE') }}
      </h2>
      <p class="text-sm text-n-slate-11">
        {{ t('BRAIN.NO_ASSISTANT.DESCRIPTION') }}
      </p>
    </div>
  </div>
</template>
